/**
 * Address display formatting.
 *
 * Every listing-address-builder across the backend (data-api's listings,
 * events, ask, and neighborhoods routes) independently builds `address`
 * WITHOUT the unit number, exposing it separately as `unitNumber` - so any
 * UI that displays `address` alone silently drops the apt/unit. Confirmed
 * live 2026-09: two of three property-tile components (NeighborhoodModal,
 * GeographyModal) had exactly this bug, independently, despite being
 * near-identical sibling components - there was no shared formatter to
 * fix once. This is that formatter.
 */
/**
 * Build a single display string from a street address and an optional unit
 * number, e.g. "123 Front St" + "204" -> "123 Front St #204".
 *
 * Normalizes unit_number's real-world inconsistent formatting (confirmed
 * during the mls-sync duplicate-listing investigation: some rows store a
 * bare number like "126", others store "Unit 126") to a single "#126"
 * suffix either way, so callers never render "#Unit 126".
 *
 * Falls back to `buildingName` when `address` is empty (e.g. a unit with no
 * street address on file yet).
 */
export function formatListingAddress(listing) {
    const base = (listing.address || listing.buildingName || '').trim();
    const rawUnit = (listing.unitNumber || '').toString().trim();
    if (!rawUnit)
        return base;
    const unit = rawUnit.replace(/^unit\s+/i, '');
    return base ? `${base} #${unit}` : `#${unit}`;
}
//# sourceMappingURL=address.js.map